<template>
  <div ref="playerElement" id="playerElement"></div>
</template>

<script>

import vuexStore from '../../store/vuexStore'
import { store } from '../../store/store'

import race from '../../assets/audio/race.mp3'
import match from '../../assets/audio/vSoccer/stadium_theme.mp3'

import stadiumDrumBeat from '../../assets/audio/vSoccer/stadium_drum_beat.mp3'
import fansCheering1 from '../../assets/audio/vSoccer/fans_cheering_1.mp3'
import fansCheering2 from '../../assets/audio/vSoccer/fans_cheering_2.mp3'
import fansCheering3 from '../../assets/audio/vSoccer/fans_cheering_3.mp3'

import soccerStadiumJPAudio from '../../assets/audio/vSoccer/stadium_jp.mp3'
import dogsLocalJPAudio from '../../assets/audio/local_jp.mp3'
// import soccerChampionJPAudio from '../../assets/audio/vSoccer/champion_jp.mp3'

export default {
  props: {
    seek: {
      type: Number,
      default: 0
    },
    videoLink: {
      type: String
    },
    placeholder: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      showVideo: false,
      hasAudioEnabled: vuexStore.state.hasAudioEnabled,
      isFootballMatch: store.getGameName().toLowerCase().includes('football'),
      backgroundTheme: store.getGameName().toLowerCase().includes('football') ? match : race,
      jackpotAudio: null,
      mainBackgroundAudio: null,
      additionalBackgroundAudio: null,
      stadiumBackgroundAudio: [stadiumDrumBeat, fansCheering1, fansCheering2, fansCheering3]
    }
  },
  mounted: function () {
    this.$emit('onPlay')
    this.play()
    this.selectJackpotAudio()
    this.$watch(
      () => vuexStore.state.hasAudioEnabled,
      () => {
        this.hasAudioEnabled = vuexStore.state.hasAudioEnabled
      }
    )
  },
  beforeDestroy: function () {
    this.clearVideo()
  },
  watch: {
    hasAudioEnabled () {
      if (this.hasAudioEnabled) {
        if (this.mainBackgroundAudio === null && this.jackpotAudio === null) {
          this.mainBackgroundAudio = new Audio(this.backgroundTheme)
          if (!this.isFootballMatch) {
            this.mainBackgroundAudio.currentTime += this.player.getCurrentTime()
          }
          this.mainBackgroundAudio.play()
        } else if (this.jackpotAudio !== null) {
          this.jackpotAudio.currentTime += this.player.getCurrentTime()
          this.jackpotAudio.play()
        }
      } else {
        if (this.mainBackgroundAudio !== null) {
          this.mainBackgroundAudio.pause()
          this.mainBackgroundAudio = null
          if (this.isFootballMatch && this.additionalBackgroundAudio !== null) {
            this.additionalBackgroundAudio.pause()
            this.additionalBackgroundAudio = null
          }
        }
        if (this.jackpotAudio !== null) {
          this.jackpotAudio.pause()
        }
      }
    },
    videoLink: function (val, old) {
      if (val) {
        this.play()
      }
    },
    seek: function (val, old) {
      if (val !== old && val > 2) {
        this.player.seek(val)
      }
    }
  },
  computed: {
    player: function () {
      // eslint-disable-next-line no-undef
      return jwplayer('playerElement')
    }
  },
  methods: {
    selectJackpotAudio () {
      if (this.isFootballMatch) {
        if (this.videoLink.includes('stadium')) {
          if (this.mainBackgroundAudio !== null) {
            this.mainBackgroundAudio.pause()
            this.mainBackgroundAudio = null
          }
          this.jackpotAudio = new Audio(soccerStadiumJPAudio)
          if (this.hasAudioEnabled) {
            this.jackpotAudio.play()
          }
        }
      } else {
        if (this.videoLink.includes('local_jp')) {
          if (this.mainBackgroundAudio !== null) {
            this.mainBackgroundAudio.pause()
            this.mainBackgroundAudio = null
          }
          this.jackpotAudio = new Audio(dogsLocalJPAudio)
          if (this.hasAudioEnabled) {
            this.jackpotAudio.play()
          }
        }
      }
    },
    clearVideo () {
      try {
        this.player.remove()
        if (this.mainBackgroundAudio !== null) {
          this.mainBackgroundAudio.pause()
          this.mainBackgroundAudio = null
        }
        if (this.additionalBackgroundAudio !== null) {
          this.additionalBackgroundAudio.pause()
          this.additionalBackgroundAudio = null
        }
        if (this.jackpotAudio !== null) {
          this.additionalBackgroundAudio.pause()
          this.additionalBackgroundAudio = null
        }
      } catch (e) {}
    },
    onLoad () {
      try {
        try {
          this.player.setup({
            'file': this.videoLink,
            'image': this.placeholder,
            controls: false,
            mute: true,
            autostart: true
          })
          if (this.isFootballMatch) {
            setInterval(() => {
              if (this.mainBackgroundAudio !== null) {
                // if (Math.round(this.mainBackgroundAudio.currentTime) === Math.floor(Math.random() * (40 - 25)) + 25) {
                if (Math.round(this.mainBackgroundAudio.currentTime) === 37) {
                  this.additionalBackgroundAudio = new Audio(this.stadiumBackgroundAudio[Math.floor(Math.random() * 4)])
                  this.additionalBackgroundAudio.play()
                }
                if (Math.round(this.mainBackgroundAudio.currentTime) === 60) {
                  var tempBackgroundAudio = this.mainBackgroundAudio
                  this.mainBackgroundAudio = new Audio(this.backgroundTheme)
                  this.mainBackgroundAudio.play()
                  setTimeout(() => {
                    tempBackgroundAudio.pause()
                    tempBackgroundAudio = null
                  }, 3000)
                }
              }
            }, 1000)
          }
        } catch (e) {}

        this.player.on('ready', () => {
          try {
            this.player.on('pause', () => {
              this.player.play()

              this.$emit('onPause')
            })
          } catch (e) {}

          try {
            this.player.on('error', (evt) => {
              this.$emit('onError', evt)
            })
          } catch (e) {}

          try {
            this.player.on('time', (data, err) => {
              this.$emit('onTime', {
                'data': data,
                'error': err
              })
            })
          } catch (e) {}

          try {
            this.player.on('time', (data, err) => {
              this.$emit('onTime', {
                'data': data,
                'error': err
              })
            })
          } catch (e) {}

          try {
            this.player.on('complete', (e) => {
              this.$emit('onComplete')
              this.clearVideo()
            })
          } catch (e) {}

          if (this.seek <= 2) {
            if (this.hasAudioEnabled && this.jackpotAudio === null) {
              this.mainBackgroundAudio = new Audio(this.backgroundTheme)
              this.mainBackgroundAudio.play()
            }
          } else if (this.seek > 2) {
            try {
              this.player.seek(this.seek + 1)
              if (this.hasAudioEnabled && this.jackpotAudio === null) {
                this.mainBackgroundAudio = new Audio(this.backgroundTheme)
                if (!this.isFootballMatch) {
                  this.mainBackgroundAudio.currentTime += this.seek
                }
                this.mainBackgroundAudio.play()
              }
            } catch (e) {}
          }
        })
      } catch (e) { }
    },
    play () {
      try {
        if (this.videoLink) {
          // eslint-disable-next-line no-undef
          if (jwplayer) {
            this.onLoad()
            // var audio = new Audio(race)
            // audio.play()
          }
        }
      } catch (e) {
        const script = document.createElement('script')
        script.onload = this.onLoad
        script.src = 'https://cdn.jwplayer.com/libraries/K6AKqjxr.js'
        document.head.appendChild(script)
      }
    }
  }
}
</script>
